/*
 *  I10DIAEFCOLCalcul.ts
 *
 *  Created by Node Generator on Sun Aug 10 2025 19:21:38 GMT+0200 (Central European Summer Time)
 *  Copyright © 2025 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { fetchCanalisationDebitMinMax, fetchCoefficientMajorationBatiment, fetchDebitPlomberie, fetchTube } from '@batical/data/src'
import i18n from '@batical/i18n'
import { I10DIAEFCOL_State, RDebitPlomberieSchema_Type } from '@batical/types/src'

function I10DIAEFCOL_docalcul(state: I10DIAEFCOL_State) {
  let selectedcoeffMajoration = fetchCoefficientMajorationBatiment(state.coeffMajoration)
  let selectedtube_uuid = fetchTube(state.tube_uuid)
  let selectedcanalisationdebit_uuid = fetchCanalisationDebitMinMax(state.canalisationdebit_uuid)

  state.res_debitBase = 0.0
  state.res_debitBase += calculPlomberie('1', state.in_evier)
  state.res_debitBase += calculPlomberie('2', state.in_lavabo)
  state.res_debitBase += calculPlomberie('3', state.in_bidet)
  state.res_debitBase += calculPlomberie('4', state.in_baignoire)
  state.res_debitBase += calculPlomberie('5', state.in_douche)
  state.res_debitBase += calculPlomberie('6', state.in_robinetdemi)
  state.res_debitBase += calculPlomberie('7', state.in_robinetquart)
  state.res_debitBase += calculPlomberie('8', state.in_lavemain)
  state.res_debitBase += calculPlomberie('9', state.in_baclaver)
  state.res_debitBase += calculPlomberie('10', state.in_linge)
  state.res_debitBase += calculPlomberie('11', state.in_vaiselle)
  //state.res_somme_debit = 60 * state.res_somme_debit;
  let sum =
    state.in_evier +
    state.in_lavabo +
    state.in_bidet +
    state.in_baignoire +
    state.in_douche +
    state.in_robinetdemi +
    state.in_robinetquart +
    state.in_lavemain +
    state.in_baclaver +
    state.in_linge +
    state.in_vaiselle

  if (sum > 0) {
    state.res_coeffSimul = selectedcoeffMajoration.coeffMajoration / Math.sqrt(sum - 1)
    state.res_debitProbable = state.res_debitBase * state.res_coeffSimul
    state.res_diamIntRecommande = 22.9 * Math.pow(state.res_debitProbable / 0.278, 0.4) // state.res_coeffSimul * state.res_debitProbable
    state.res_vitesseSilMax = Math.pow(state.res_diamIntRecommande / 50, 0.5)
    state.res_vitesseReelle = state.res_debitProbable / 1000.0 / (0.7854 * Math.pow(selectedtube_uuid.diamInt / 1000, 2))

    if (selectedcanalisationdebit_uuid.debitMax < state.res_vitesseReelle) {
      state.res_diamConforme = i18n.t('I10DIABOUCECS_nonconforme')
    } else if (state.res_vitesseReelle > 0.2) {
      state.res_diamConforme = i18n.t('I10DIABOUCECS_conforme')
    } else {
      state.res_diamConforme = i18n.t('I10DIABOUCECS_nonconforme')
    }
  } else {
    state.res_coeffSimul = 0
    state.res_debitProbable = 0
    state.res_diamIntRecommande = 0
    state.res_vitesseSilMax = 0
    state.res_vitesseReelle = 0
    state.res_diamConforme = ''
  }

  return state
}

export default I10DIAEFCOL_docalcul
function calculPlomberie(type: string, quantite: number): number {
  let debs: RDebitPlomberieSchema_Type = fetchDebitPlomberie(type)

  return quantite * debs.debit
}
